module.exports = __webpack_public_path__ + "static/media/brindes.cdfd39f6.jpg";